import '../css/base.css';
import '../css/layout.css';
import '../css/components/buttons.css';
import '../css/components/forms.css';
import '../css/components/modals.css';
import '../css/components/crew.css';
import '../css/components/legend.css';
import '../css/components/loader.css';
import '../css/components/stats.css';
import '../css/components/lists.css';
import '../css/utility.css';
import '../css/lib/mapbox-gl.css';
import '../css/lib/mapbox-gl-draw.css';

import { ready } from './utils.js';
import { cacheDomElements } from './dom.js';
import { checkSession } from './auth.js';
import { initializeEventListeners, updateActionButtons, createActionButtons, showTracks, showTrip, showBoat } from './ui.js';

function initializeApp() {
  cacheDomElements();
  createActionButtons();
  checkSession();
  initializeEventListeners();
  updateActionButtons('tracks');
}

ready(initializeApp);
